"use strict";

import autosize from "autosize/dist/autosize";

autosize(document.querySelectorAll('textarea'));
